<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.operLog"
    :search="search"
    sort-by="rowId"
    class="elevation-1"
  >
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-3">
            <!-- :hint="`選單功能, ${select.value}`" -->
            <v-select
              v-model="select"
              :items="$store.state.childrenMenu"
              item-text="name"
              item-value="value"
              label="Select"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <div class="col-sm-12 col-md-4 col-lg-3">
            <v-text-field
              v-model="queryName"
              label="請輸入使用者姓名"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-3">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="dates"
              persistent
              width="290px"
            >
              <!-- 手動輸入日期 -->
              <div class="pa-2" style="background-color: #fff">
                <v-text-field
                  label="填寫日期"
                  prepend-icon="event"
                  v-model="dateRangeTextInput"
                  :placeholder="dateRangeText"
                  @keyup="textInputDate"
                  @click="getDateRang"
                ></v-text-field>
              </div>
              <template v-slot:activator="{ on }">
                <v-text-field
                  slot-scope=""
                  v-model="dateRangeText"
                  label="建立時間"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                locale="zh-tw"
                selected-items-text="已選擇兩個日期"
                range
                @change="clearTextInput"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">取消</v-btn>
                <!-- <v-btn text color="primary" @click="$refs.dialog.save(dates)">確認</v-btn> -->
                <v-btn text color="primary" @click="saveDates(dates)">確認</v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query"
              >查詢</v-btn
            >
          </div>
        </div>
      </div>
    </template>

    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
export default {
  created() {
    this.$store.commit('getDate')
    this.dates[0] = this.$store.state.date.lastMonth
    this.dates[1] = this.$store.state.date.current
  },
  data: () => ({
    valid: true,
    search: '',
    dialog: false,
    disabled: false,
    select: { name: '請選擇', value: null },
    queryName: '',
    useTypeItem: ['正常使用', '暫停使用', '不再使用'],
    headers: [
      //{ text: '', value: 'rowId', sortable: false },
      { text: '序號', value: 'rowId' },
      { text: '流水編號', value: 'rowId' },
      { text: '操作序號', value: 'actSerial' },
      { text: '功能名稱', value: 'menuName' },
      { text: '系統動作', value: 'actTypeName' },
      { text: '資料表', value: 'tableName' },
      { text: '異動主鍵值', value: 'tblPrimaryKeysAndValues' },
      { text: '結果', value: 'resultCode' },
      { text: '錯誤訊息', value: 'errMsg' },
      { text: '使用者', value: 'userName' },

      { text: '操作IP', value: 'actIp' },
      { text: '系統時間', value: 'logDate' },
    ],
    //日期
    dates: [],
    dateRangeTextInput: '',
    menu: false,
    modal: false,
    menu2: false,
    userData: [],
  }),
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
  },
  methods: {
    query() {
      const str = this.dateRangeText.replace(/\s/g, '')
      const dateTime = str.split('~')
      let url = this.$store.state.api + '/S00120/QueryOperLog'
      let data = Object.assign(
        { queryType: this.select },
        { queryName: this.queryName },
        { strDate: dateTime[0] },
        { endDate: dateTime[1] }
      )
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        this.$store.state.operLog.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          for (var i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]
            this.$store.state.operLog.push(row)
            window.console.log(row)
          }
        } else {
          alert(res.data.error)
        }
      })
    },
    getDateRang() {
      this.dateRangeTextInput = this.dateRangeText
    },
    textInputDate() {
      const str = this.dateRangeTextInput.replace(/\s/g, '')
      this.dates = str.split('~')
    },
    clearTextInput() {
      this.dateRangeTextInput = ''
    },
    saveDates(dates) {
      //判斷有~連接
      if (
        this.dateRangeText.indexOf('~') != -1
      ) {
        //只能是數字
        const reg = /(\d+)-(\d+)-(\d+)/
        const matched1 = dates[0].match(reg)
        const matched2 = dates[1].match(reg)
        let YYYY = [0, 0]
        let MM = [0, 0]
        let DD = [0, 0]
        if (matched1 && matched2) {
          //字數判定日期格式
          let dateStart = dates[0].split('-')
          let dateEnd = dates[1].split('-')
          let year = [dateStart[0], dateEnd[0]]
          let month = [dateStart[1], dateEnd[1]]
          let date = [dateStart[2], dateEnd[2]]
          for (let i = 0; i < year.length; i++) {
            YYYY[i] = (0 < year[i]) + (year[i] < 10000) //=>2 1~9999年
            MM[i] = (0 < month[i]) + (month[i] < 13) //=>2 1~12月
            DD[i] = 0

            //判斷日期天數
            let dateRangCase = 0
            if (month[i] == 2) {
              if (month[i] % 4 == 0) {
                dateRangCase = 0 //閏年2月 29天
              } else {
                dateRangCase = 1 //非潤2月 28天
              }
            } else {
              if (1 <= month[i] && month[i] <= 7) {
                //1~7月 非2月
                if (month[i] % 2 == 0) {
                  dateRangCase = 2 //30天
                } else {
                  dateRangCase = 3 //31天
                }
              } else {
                // 8~12月
                if (month[i] % 2 == 0) {
                  dateRangCase = 3 //31天
                } else {
                  dateRangCase = 2 //30天
                }
              }
            }
            switch (dateRangCase) {
              case 0:
                DD[i] = (0 < date[i]) + (date[i] < 30) //29天
                break
              case 1:
                DD[i] = (0 < date[i]) + (date[i] < 29) //28天
                break
              case 2:
                DD[i] = (0 < date[i]) + (date[i] < 31) //30天
                break
              case 3:
                DD[i] = (0 < date[i]) + (date[i] < 32) //31天
                break
            }
          }
          let datesConfirm = YYYY[0] + YYYY[1] + MM[0] + MM[1] + DD[0] + DD[1]
          if (datesConfirm == 12) {
            this.$refs.dialog.save(dates)
            window.console.log(dates)
          } else {
            alert('日期格式錯誤!')
          }
        } else {
          alert('請以數字輸入日期!')
        }
      } else {
        alert('請以"~"連接先後日期!')
      }
    },
  },
}
</script>
<style>
.v-text-field label {
  font-size: 1.4em;
}
</style>
